
// import React, { useEffect } from 'react';
// import html2pdf from 'html2pdf.js';

// const HTMLToPDF = ({ htmlAgrupamento }) => {
//     useEffect(() => {
//         const gerarPDF = async () => {
//           try {
//             const options = {
//               margin: 10,
//               filename: 'documento.pdf',
//               image: { type: 'jpeg', quality: 0.98 },
//               html2canvas: { scale: 2 },
//               jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
//             };
    
//             const element = document.createElement('div');
//             element.innerHTML = htmlAgrupamento;
    
//             await new Promise(resolve => setTimeout(resolve, 500));
    
//             const pdf = await html2pdf(element, options);
    
//             // Faz o download do arquivo PDF
//             pdf.outputPdf().then((output) => {
//               const blob = new Blob([output], { type: 'application/pdf' });
//               const url = URL.createObjectURL(blob);
//               const link = document.createElement('a');
//               link.href = url;
//               link.download = options.filename || 'documento.pdf';
//               document.body.appendChild(link);
//               link.click();
//               document.body.removeChild(link);
//               URL.revokeObjectURL(url);
//             });
//           } catch (error) {
//             console.error('Erro ao gerar o PDF:', error);
//           }
//         };
    
//         gerarPDF();
//       }, [htmlAgrupamento]);

//     return <div>Realizando download...</div>;
// };

// export default HTMLToPDF;
